<h2>
  <label class="key">סטטוס עוגנים לקמפיין:
    <span class="val">{{data.campaignName}}</span>
  </label>
</h2>
<mat-dialog-content >
  <table mat-table [dataSource]="campaignStatusDetails" class="details-table" matSort >
    <ng-container matColumnDef="destination">
      <th mat-header-cell  *matHeaderCellDef class="text-right anchor"> עוגן </th>
      <td mat-cell  *matCellDef="let element" class="anchor"> {{element.anchor}} </td>
    </ng-container>
    <ng-container matColumnDef="avatarId">
      <th mat-header-cell *matHeaderCellDef class="text-right avatar"> אווטאר </th>
      <td mat-cell *matCellDef="let element" class="text-right avatar"> {{element.avatarId}} </td>
    </ng-container>
    <ng-container matColumnDef="createDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-right create-date"> תאריך </th>
      <td mat-cell *matCellDef="let element" class="create-date"> {{element.createDate | date:"HH:mm dd/MM/yyyy"}} </td>
    </ng-container>
    <ng-container matColumnDef="comment">
      <th mat-header-cell *matHeaderCellDef class="text-right"> קישור לפוסט </th>
      <td mat-cell *matCellDef="let element">
        @for (p of element.postId; track p; let i = $index) {
          <a  href="{{element.anchor}}/{{p}}" class="post_link" target="_blank">
            קישור {{i+1}}
          </a>
          @if (element.postId?.length>i+1) {
            ,
          }
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsDetails"></tr>
    <tr mat-row  *matRowDef="let row; columns: displayedColumnsDetails;" ></tr>
  </table>
</mat-dialog-content>

<mat-paginator #paginator [pageSizeOptions]="[10, 20, 50]" aria-label="Select">
</mat-paginator>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>סגור</button>
</mat-dialog-actions>
